module.exports = __webpack_public_path__ + "static/media/f1_image@2x.980775e8.png";